/**
 * 무적화물 전용 화면의 조건.
 *
 * 입고 스캔 화면은 조건 없이 `/api/scan/orphans` 를 부른다(아직 안 이은 상자, 최근 순).
 * 전용 화면은 **같은 라우트에** 조건을 실어 보낸다 — 목록을 읽는 길이 둘이 되면
 * 같은 상자가 한쪽에만 보이는 일이 생긴다.
 *
 * 조건은 URL 에 둔다(반품 목록과 같은 규칙) — 뒤로가기·링크 공유가 그냥 되고,
 * JSX 안 조건식으로 두면 테스트할 수 없다.
 */

/** 서버가 받는 값(`server/src/repos/orphan-cargo-repo.ts` 의 orphanQuerySchema). */
export const ORPHAN_STATUSES = ["open", "resolved"] as const

export type OrphanStatus = (typeof ORPHAN_STATUSES)[number]

/** 한 쪽에 보여 줄 수. 반품 목록과 같다. */
const PAGE_SIZE = 50

/**
 * 지금 고른 잇기 여부. **URL 에 없으면 `open`** — 처음 열었을 때 할 일(아직 안 이은
 * 상자)이 먼저 보여야 한다. 칩에서 "전체" 를 고르면 `all` 이 URL 에 적힌다.
 */
export function orphanStatusOf(params: URLSearchParams): OrphanStatus | null {
  const raw = params.get("status")
  if (raw === "all") return null
  return raw === "resolved" ? "resolved" : "open"
}

/** 목록을 다시 읽을 조건만 남긴 질의 문자열. `detail` 은 옆판을 여닫을 뿐이다. */
export function orphanListQuery(params: URLSearchParams, size: number = PAGE_SIZE): string {
  const next = new URLSearchParams()
  // 칩에서 "전체" 를 고른 것(null)과 아직 아무것도 고르지 않은 것을 가른다.
  next.set("status", orphanStatusOf(params) ?? "all")

  const q = (params.get("q") ?? "").trim()
  if (q !== "") next.set("q", q)

  const page = Number(params.get("page"))
  if (Number.isInteger(page) && page > 1) next.set("page", String(page))

  const asked = Number(params.get("size"))
  next.set("size", String(Number.isInteger(asked) && asked > 0 ? asked : size))
  return next.toString()
}
